import React from "react"
import { useState } from "react"

const messages = [
    {
      id: 1,
      subject: 'Universitas Gadjah Mada',
      sender: '2nd Place at Joints Programming Competition 2021',
      time: 'April 2021',
      datetime: '2021-01-27T16:35',
      preview:
        '2nd Place at Joints Programming Competition 2021 held by Universitas Gadjah Mada, Indonesia.',
    },
    {
        id: 2,
        subject: 'Shopee',
        sender: '7th Place at Shopee Code League 2021 - Student Category',
        time: 'April 2021',
        datetime: '2021-01-27T16:35',
        preview:
          '7th place at Shopee Code League 2021 Student Category (9th place overall) held by Shopee, scoring 264 points across three competitions (data analytics, data science and competitive programming).',
      },
      {
        id: 3,
        subject: 'ICPC Regional Jakarta',
        sender: 'National Silver Medalist at ICPC Asia Jakarta 2020',
        time: 'December 2020',
        datetime: '2021-01-27T16:35',
        preview:
          'National silver medalist at International Collegiate Programming Contest for undergraduate student in Asia, hosted by Binus University, Indonesia.',
      },
      {
        id: 4,
        subject: 'Binus University',
        sender: '7th Place at ICPC Indonesia National Contest 2020',
        time: 'November 2020',
        datetime: '2021-01-27T16:35',
        preview:
          '7th place at National Programming Competition held by Binus University, Indonesia.',
      },
      {
        id: 5,
        subject: 'University of Indonesia',
        sender: 'Honorable Mention (Top 5) at Competitive Programming Contest COMPFEST 2020',
        time: 'September 2020',
        datetime: '2021-01-27T16:35',
        preview:
          'Honorable Mention (Top 5) at Competitive Programming Contest COMPFEST 2020',
      },
      {
        id: 6,
        subject: 'ICPC Regional Kuala Lumpur',
        sender: '13th Place at ICPC Asia Kuala Lumpur Regional Contest',
        time: 'November 2019',
        datetime: '2021-01-27T16:35',
        preview:
          '13th place at International Collegiate Programming Contest for undergraduate student in Asia, hosted by International Islamic University Malaysia (IIUM), Malaysia.',
      },
      {
        id: 7,
        subject: 'Binus University',
        sender: '18th Place at ICPC Indonesia National Contest 2019',
        time: 'October 2019',
        datetime: '2021-01-27T16:35',
        preview:
          '18th place at National Programming Competition held by Binus University, Indonesia.',
      },
      {
        id: 8,
        subject: 'ICPC Regional Jakarta',
        sender: 'National Bronze Medalist at ICPC Asia Jakarta 2019',
        time: 'October 2019',
        datetime: '2021-01-27T16:35',
        preview:
          'National bronze medalist at International Collegiate Programming Contest for undergraduate student in Asia, hosted by Binus University, Indonesia.',
      },
      {
        id: 9,
        subject: 'Ministry of Education, Culture, Research and Technology',
        sender: 'Silver Medalist at Indonesia NOI (National Olympiad in Informatics) 2018',
        time: 'July 2018',
        datetime: '2021-01-27T16:35',
        preview:
          'Silver Medalist at Indonesia NOI also known as OSN (Olimpiade Sains Nasional) in Informatics.',
      },
      {
        id: 10,
        subject: 'Universitas Multimedia Nusantara',
        sender: '1st Place at Junior CPC Festival 2017',
        time: 'October 2017',
        datetime: '2021-01-27T16:35',
        preview:
          '1st Place at Junior CPC Festival 2017 held by Universitas Multimedia Nusantara, Indonesia.',
      },
    // More messages...
  ]
  

const Award = () => {
	const [isVisible, setstate] = useState(false)

	const toggleVisible = () => {
		setstate(!isVisible)
	}
    
	return (
        <><div className='w-full h-full flex flex-col place-items-center mt-12'>
            <div className='flex justify-between mb-8'>
                <div className='text-blue-400 text-4xl font-bold mt-16 underline'>Awards</div>
            </div>
        </div><ul className="divide-y divide-gray-200 ml-16 mr-16 mb-8">
            {messages.map((message) => (
                <li
                key={message.id}
                className="relative bg-white py-5 px-4 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600"
                >
                <div className="flex justify-between space-x-3">
                    <div className="min-w-0 flex-1">
                    <a href="#" className="block focus:outline-none">
                        <span className="absolute inset-0" aria-hidden="true" />
                        <p className="text-sm font-medium text-gray-900 truncate">{message.sender}</p>
                        <p className="text-sm text-gray-600 truncate">{message.subject}</p>
                    </a>
                    </div>
                    <time dateTime={message.datetime} className="flex-shrink-0 whitespace-nowrap text-sm text-gray-500">
                    {message.time}
                    </time>
                </div>
                <div className="mt-1">
                    <p className="line-clamp-2 text-sm text-gray-600">{message.preview}</p>
                </div>
                </li>
            ))}
            </ul></>
	)
}

export default Award
